import { uploadActionTypes } from '../actions/upload-action-types';
import { removeItemFromSetAndCreateNew } from '../../common/reducer-helpers';

const uploadInitialState = {
	filesToUpload: new Set(),
	uploadedFiles: new Set(),
	errors: new Set(),
	maximumConcurrentUploads: 5,
	totalProgress: 0,
	fileProgress: new Map(),
	uploadStarted: 0,
	completeUploads: [],
	currentUploadsComplete: false,
	currentAlbumId: 0,
	currentAlbumName: '',
	uploadFileQueue: [],
	uploadActive: true,
	uploadStop: false,
	thumbsProcessed: [],
	isCancelDownloadDialogOpen: false,
	uploadComplete: false

};

export const upload = (state = uploadInitialState, action) => {
	switch (action.type) {
		case uploadActionTypes.UPLOAD_ENQUEUE_ITEM:
			return {
				...state,
				uploadFileQueue: [...state.uploadFileQueue, action.file]
			};

		case uploadActionTypes.UPLOAD_DEQUEUE_ITEM:
			if(state.uploadFileQueue.length < 1) {
				return state;
			}
			return {
				...state,
				uploadFileQueue: [...state.uploadFileQueue.slice(1, state.uploadFileQueue.length)],
				filesToUpload: new Set([...state.filesToUpload, action.file])
			};

		case uploadActionTypes.UPLOAD_FILE_SUCCESS:
			return {
				...state,
				filesToUpload: setSuccessForFile(state.filesToUpload, action.file),
				completeUploads: (state.completeUploads.indexOf(action.file) > -1) ? state.completeUploads : [...state.completeUploads, action.file],
				uploadStarted: state.completeUploads + 1 === state.filesToUpload.size ? 0 : state.uploadStarted
			};
		case uploadActionTypes.UPLOAD_FILE_FAILURE:
			return {
				...state,
				filesToUpload: removeItemFromSetAndCreateNew(state.filesToUpload, action.file),
				uploadStarted: state.completeUploads.length + 1 === state.filesToUpload.size ? 0 : state.uploadStarted,
				completeUploads: [...new Set([...state.completeUploads, action.file]).values()]
			};
		case uploadActionTypes.UPLOAD_FILE_REQUEST:
			return {
				...state
				//filesToUpload: new Set([...state.filesToUpload, action.file])
			};

		case uploadActionTypes.UPLOAD_FILE_PROGRESS:
			return {
				...state,
				filesToUpload: setProgressForFile(state.filesToUpload, action.file, action.progress, {
					total: action.total,
					loaded: action.loaded
				})
			};

		case uploadActionTypes.UPLOAD_FILE_STARTED: {
			return {
				...state,
				//filesToUpload: new Set([...state.filesToUpload, action.file]),
				uploadStarted: state.uploadStarted ? state.uploadStarted : Date.now(),
				currentUploadsComplete: false
			};
		}

		case uploadActionTypes.UPLOAD_FILE_COMPLETE: {
			return {
				...state,
				uploadedFiles: removeItemFromSetAndCreateNew(state.uploadedFiles, action.file)
			};
		}

		case uploadActionTypes.UPLOAD_CLEAR_ITEMS: {
			return {
				...state,
				uploadedFiles: new Set(),
				filesToUpload: new Set(),
				uploadFileQueue: [],
				completeUploads: [],
				uploadStarted: 0
			};
		}

		case uploadActionTypes.UPLOAD_CURRENT_COMPLETE: {
			return {
				...state,
				currentUploadsComplete: true,
				currentAlbumId: action.albumId
			};
		}

		case uploadActionTypes.UPLOAD_SET_CURRENT_ALBUM: {
			return {
				...state,
				currentAlbumId: action.albumId,
				currentAlbumName: action.albumName
			};
		}

		case uploadActionTypes.UPLOAD_CONTINUE: {
			return {
				...state,
				uploadActive: true
			};
		}
		case uploadActionTypes.UPLOAD_STOP: {
			return {
				...state,
				uploadStop: true
			};
		}
		case uploadActionTypes.UPLOAD_RESTART: {
			return {
				...state,
				uploadStop: false
			};
		}
		case uploadActionTypes.UPLOAD_THUMB_PROCESSED: {
			return {
				...state,
				thumbsProcessed: [...state.thumbsProcessed, action.thumb]
			};
		}

		case uploadActionTypes.UPLOAD_CANCEL_DIALOG_TOGGLE: {
			return {
				...state,
				isCancelDownloadDialogOpen: !state.isCancelDownloadDialogOpen
			};
		}
		
		case uploadActionTypes.UPLOAD_UPLOADS_COMPLETE: {
			return {
				...state,
				uploadComplete: true
			};
		}
		case uploadActionTypes.UPLOAD_UPLOADS_INPROGRESS: {
			return {
				...state,
				uploadComplete: false
			};
		}

		
		



		case uploadActionTypes.UPLOAD_PAUSE: {

			state.filesToUpload.forEach(file=>{
				if(file.request && file.request.abort) {
					file.request.abort();
				}
			});

			return {
				...state,
				uploadActive: false,
				filesToUpload: new Set(),
				uploadFileQueue: [...state.uploadFileQueue, ...state.filesToUpload]
			};
		}

		default:
			return state;
	}
};

const setProgressForFile = (fileSet, file, progressValue, progressStats) => {
	const returnSet = new Set([...fileSet.values()]);

	if (returnSet.has(file)) {
		returnSet.delete(file);
		file.progress = progressValue;
		file.inProgress = true;
		file.waiting = false;
		file.progressStats = progressStats;
		returnSet.add(file);
	}

	return returnSet;
};

// const fileProgressChanged = (fileSet, file, progressValue, progressStats) => {
// 	return (file.progress === progressValue & file.progressStats === progressStats)
// };

const setSuccessForFile = (fileSet, file) => {
	const returnSet = new Set([...fileSet.values()]);
	if (returnSet.has(file)) {
		returnSet.delete(file);
	}
	return returnSet;
};



// WEBPACK FOOTER //
// ./src/upload/reducers/upload-reducers.js